import { request } from '@/utils/api/request';

import { ENDPOINT } from '@/constants/api';

export const affiliates = {
  getHistory({ signal } = {}) {
    return request.get({
      endpoint: ENDPOINT.AUTH,
      signal,
      url: '/referrals/history',
    });
  },
  getLink({ signal } = {}) {
    return request.get({
      endpoint: ENDPOINT.AUTH,
      signal,
      url: '/referrals/link',
    });
  },
  getPayout({ signal } = {}) {
    return request.get({
      endpoint: ENDPOINT.AUTH,
      signal,
      url: '/referrals/payout',
    });
  },
  getPayoutMethod({ signal } = {}) {
    return request.get({
      endpoint: ENDPOINT.AUTH,
      signal,
      url: '/referrals/affiliates/config',
    });
  },
  sendApplicationSurvey({ payload, signal }) {
    return request.post({
      endpoint: ENDPOINT.AUTH,
      payload,
      signal,
      url: '/referrals/affiliates/survey',
    });
  },
  setPayoutMethod({ handle, signal }) {
    return request.post({
      endpoint: ENDPOINT.AUTH,
      payload: {
        payment_methods: {
          paypal_handle: handle,
        },
      },
      signal,
      url: '/referrals/affiliates/config',
    });
  },
};
